import { createApi } from "@reduxjs/toolkit/query/react";

import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type {
  TGetCheckInConfigurationRequest,
  TGetCheckInConfigurationResponse,
  TResetCheckInConfigurationRequest,
  TResetCheckInConfigurationResponse,
  TUpdateCheckInConfigurationRequest,
  TUpdateCheckInConfigurationResponse,
} from "@/types/(company)/checkInConfiguration.interface";

export const companyCheckinCheckoutConfigApi = createApi({
  reducerPath: "companyCheckinCheckoutConfigApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["getCheckInConfig"],
  endpoints: (builder) => ({
    getCheckInConfig: builder.query<
      TGetCheckInConfigurationResponse,
      TGetCheckInConfigurationRequest
    >({
      query: () => {
        return {
          url: "/company/settings/checkin-checkout-config",
          method: "GET",
        };
      },
      providesTags: ["getCheckInConfig"],
    }),
    resetCheckInConfig: builder.mutation<
      TResetCheckInConfigurationResponse,
      TResetCheckInConfigurationRequest
    >({
      query: () => {
        return {
          url: "/company/settings/checkin-checkout-config/reset",
          method: "POST",
        };
      },
      invalidatesTags: ["getCheckInConfig"],
    }),
    updateCheckInConfig: builder.mutation<
      TUpdateCheckInConfigurationResponse,
      TUpdateCheckInConfigurationRequest
    >({
      query: (body) => {
        return {
          url: "/company/settings/checkin-checkout-config",
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: ["getCheckInConfig"],
    }),
  }),
});

export const {
  useGetCheckInConfigQuery,
  useResetCheckInConfigMutation,
  useUpdateCheckInConfigMutation,
} = companyCheckinCheckoutConfigApi;
